import { render, staticRenderFns } from "./CreateEditModalMedioAmbiente.vue?vue&type=template&id=1a97faaa&scoped=true&"
import script from "./CreateEditModalMedioAmbiente.vue?vue&type=script&lang=ts&"
export * from "./CreateEditModalMedioAmbiente.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEditModalMedioAmbiente.vue?vue&type=style&index=0&id=1a97faaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97faaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1a97faaa', component.options)
    } else {
      api.reload('1a97faaa', component.options)
    }
    module.hot.accept("./CreateEditModalMedioAmbiente.vue?vue&type=template&id=1a97faaa&scoped=true&", function () {
      api.rerender('1a97faaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MedioAmbiente/HuellaCarbono/CreateEditModalMedioAmbiente.vue"
export default component.exports